import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DriversService {
  constructor(private readonly http: HttpClient) {}

  public syncDriversList(): Observable<any> {
    return this.http.get(`${environment.mainapiUrl}/drivers`);
  }
}
